import { createComponent } from '@carvana/merch-components';
import rollingStyles from './RollingNumber.module.css';

export const RollingNumberContainer = createComponent('span', {
  className: 'inline-flex'
});

export const DigitTrack = createComponent('span', {
  className: `block ${rollingStyles.digit}`
});

export const DigitClip = createComponent('span', {
  className: 'h-[1em] inline-block overflow-hidden leading-[1em]',
  'aria-hidden': true
});

export const DigitCell = createComponent('span', {
  className: 'block overflow-hidden leading-[1em] h-[1em] tabular-nums'
});

export const Separator = createComponent('span', {
  className: 'block h-[1em] tabular-nums leading-[1em]',
  'aria-hidden': true
});
